import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';

import { Typography } from '@zendesk/forethought-elements';

interface InsightCardProps {
  headerRightText?: string;
  isFetching?: boolean;
  isLoading?: boolean;
  justifyContent?: string;
  size?: 'large' | 'small';
  title?: string;
  tooltip?: React.ReactNode;
}

const InsightCard: React.FC<React.PropsWithChildren<InsightCardProps>> = ({
  children,
  headerRightText,
  isFetching,
  isLoading,
  justifyContent = 'space-between',
  size = 'small',
  title,
  tooltip,
}) => {
  const { palette } = useTheme();
  return (
    <Box
      sx={{
        border: `1px solid ${palette.colors.slate[200]}`,
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        height: size === 'small' ? 370 : undefined,
        justifyContent: justifyContent,
        minWidth: size === 'small' ? '419px' : 'calc(50% - 12px)',
        p: '24px',
      }}
    >
      {isLoading || isFetching ? (
        <>
          <Skeleton height={22}></Skeleton>
          <Skeleton height={size === 'small' ? 150 : 274} />
        </>
      ) : (
        <>
          {!isLoading && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  gap: 1,
                }}
              >
                <Typography variant='font16Bold'>{title}</Typography>
                {tooltip}
              </Box>
              <Typography color={palette.colors.grey[600]} variant='font12'>
                {headerRightText}
              </Typography>
            </Box>
          )}
          {children}
        </>
      )}
    </Box>
  );
};

export default InsightCard;
